import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ModuleLoader } from '@wix/thunderbolt-renderer-utils'
import { PromiseCacheSymbol } from './symbols'
import type { IPromiseCache } from './types'
import type { BrowserWindow } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'

export const ESMLoaderFactory = withDependencies(
	[PromiseCacheSymbol, BrowserWindowSymbol],
	(promiseCache: IPromiseCache, browserWindow: BrowserWindow): ModuleLoader => {
		const scriptsCache: Record<string, any> = {}
		return {
			prefetchScript: (_url) => {
				// not implemented for esm
			},
			loadModule: async (url) => {
				const cached = scriptsCache[url]
				if (cached) {
					return cached
				}

				return promiseCache.runWithCache(url, async () => {
					// if importShim is available, this means the shim has run so we need to use it
					const dynamicImport = browserWindow?.importShim ?? ((url: string) => import(/* webpackIgnore: true */ url))

					const module = await dynamicImport(url)

					scriptsCache[url] = module
					return module
				})
			},
		}
	}
)
